import React, { useEffect, useState } from "react";
import PaginatedReactDropdown from "../dropdown";
import { GridDeleteIcon } from "@mui/x-data-grid";
import Box from '@mui/material/Box';

const ACCESS_LIST = [
    { key: 'read', label: 'READ' },
    { key: 'write', label: 'WRITE' },
    { key: 'admin', label: 'ADMIN' },
    { key: 'delete', label: 'DELETE'}
  ];

const RESOURCE_NAMES = ["namespace", "global", "config"];

const getFormattedNamespace = (namespace) => {
  if (namespace == "*") {
    return "All"
  }
  return namespace
}

const getResourceCardHeader = (props) => {
    const { resourceName, userAccess, namespace, access, namespaces, handleChildChange, handleRemove, type, id } = props;

    if(!resourceName || !RESOURCE_NAMES.includes(resourceName)) return (<></>)

     return (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: 'auto', alignItems: 'center' }}> 
        <Box display="flex" alignItems={"center"} width="100%">
      <Box marginLeft={2}>
      <PaginatedReactDropdown
        options={ACCESS_LIST}
        labelKey="label"
        valueKey="key"
        handleChange={handleChildChange}
        keyToChange="access" //check this
        placeholder="Access"
        showCross={false}
        id="fileTypeDropdown"
        showPagination={false}
        value={userAccess || "READ"}
        marginTop="2rem"
      />
      </Box>
      <Box marginLeft={2}>
      {(resourceName == "namespace" || resourceName == "config") && (
        <PaginatedReactDropdown
        options={namespaces}
        labelKey="label"
        valueKey="key"
        handleChange={handleChildChange}
        keyToChange="namespace" //check this
        placeholder="Namespace"
        showCross={false}
        id="fileTypeDropdown"
        showPagination={false}
        value={getFormattedNamespace(namespace)}
        marginTop="2rem"
      />
      )}
      </Box>
      <GridDeleteIcon fontSize='large' style={{ marginLeft: "auto", marginRight: "16px"}} onClick = {(e) => handleRemove(id, type, resourceName)}  />
  
    </Box>
      </div>
     )
  };

  export default getResourceCardHeader